import Vue from "vue";
import VueI18n from "vue-i18n";

import EN from 'element-ui/lib/locale/lang/en'
import Zh_CN from 'element-ui/lib/locale/lang/zh-CN'
import ES from 'element-ui/lib/locale/lang/es'
import JA from 'element-ui/lib/locale/lang/ja'

import ZH_CNLocale from './langs/zh-CN'
import ENLocale from './langs/en'
import ESLocale from './langs/es'
import JALocale from './langs/ja'

Vue.use(VueI18n)

// localStorage.getItem("change-language") ? '' : localStorage.setItem("change-language", 'zh-CN');

// 各个国家的语言包
const messages = {
  'zh-CN': {
    ...ZH_CNLocale,
    ...Zh_CN
  },
  'en': {
    ...ENLocale,
    ...EN
  },
  'es': {
    ...ESLocale,
    ...ES
  },
  'ja': {
    ...JALocale,
    ...JA
  }
}

export default new VueI18n({
  locale: localStorage.getItem("change-language") || "zh-CN",
  messages,// 语言包
  silentTranslationWarn: true, // 忽略翻译警告
  globalInjection:true,//全局注入
  fallbackLocale:'zh-CN',// 没找到资源时使用中文
});